/**
 * Created by piotr.pozniak@thebeaverhead.com on 19/10/2018.
 */

import React, { useMemo } from "react";
import classNames from "classnames";

import styles from "./DashboardPage.module.scss";
import PageTemplate from "./../templates/PageTemplate";
import WelcomeScreen from "./DashboardPage/WelcomeScreen";
import CalendarSourcesWidget from "./DashboardPage/CalendarSourcesWidget";
import { useUserStore } from "../../../hooks/redux/user";
import { useIntegrationsStore } from "../../../hooks/redux/integrations";
import { useCurrentOrganizationStore } from "../../../hooks/redux/currentOrganization";
import CompleteWPConnection from "./DashboardPage/CompleteWPConnection";
import SubscriptionLimits from "../component/InfoWidgets/SubscriptionLimits";
import Stats from "./DashboardPage/Stats";
import EventsStats from "./DashboardPage/EventsStats";

const DashboardPage = (props) => {
  const { integrations } = useIntegrationsStore();
  const { currentOrganization } = useCurrentOrganizationStore();
  const { user } = useUserStore();

  const userModel = user.model || {};
  const orgUsage = currentOrganization.model?.usage || {};

  const hasIntegration = (orgUsage.integrations || 0) > 0;
  const hasPublishedWidget = (orgUsage.widgets || 0) > 0;
  const hasWebsite = (orgUsage.domains || 0) > 0;

  const isSetupComplete =
    Boolean(userModel.is_account_verified) && hasIntegration && hasPublishedWidget;

  const showEventsStats = hasPublishedWidget;

  const connectedIntegrationTypes = useMemo(
    () => [...new Set(integrations.collection.map((i) => i.type))],
    [integrations.collection]
  );

  return (
    <PageTemplate sidebarId="dashboard" title={"Dashboard"} icon={"home"}>
      {!isSetupComplete && (
        <div className={classNames("row", styles.setupRow)}>
          <div className={classNames("col-12", styles.cardCol)}>
            <WelcomeScreen
              isActivated={userModel.is_account_verified}
              hasSync={hasIntegration}
              connectedIntegrationTypes={connectedIntegrationTypes}
              hasCalendar={hasPublishedWidget}
              hasWebsite={hasWebsite}
            />
          </div>
        </div>
      )}

      <CompleteWPConnection />

      <div className={classNames("row", styles.topRow)}>
        {showEventsStats ? (
          <>
            <div className={classNames("col-12", "col-lg-6", styles.stackCol)}>
              <Stats />
              {hasIntegration && <CalendarSourcesWidget />}
            </div>
            <div className={classNames("col-12", "col-lg-6", styles.cardCol)}>
              <EventsStats />
            </div>
          </>
        ) : hasIntegration ? (
          <>
            <div className={classNames("col-12", "col-lg-6", styles.cardCol)}>
              <Stats />
            </div>
            <div className={classNames("col-12", "col-lg-6", styles.cardCol)}>
              <CalendarSourcesWidget />
            </div>
          </>
        ) : (
          <div className={classNames("col-12", styles.cardCol)}>
            <Stats />
          </div>
        )}
      </div>

      <div className="row">
        <div className={classNames("col-12", styles.cardCol)}>
          <SubscriptionLimits layout="horizontal" />
        </div>
      </div>
    </PageTemplate>
  );
};

export default DashboardPage;
